import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchAssignmentNotes } from '../../actions/fetchAssignmentNotesAction'
import { postAssignmentNote, clearMessages } from '../../actions/postAssignmentNoteAction'
import AddNoteSection from './AddNoteSection'
import NotesHistorySection from './NotesHistorySection'
import UploadSuccessOrFailureMessage from '../summary/UploadSuccessOrFailureMessage'

class AssignmentNotesContainer extends Component {
  state = {
    accessIndicator: false,
    noteType: '',
    noteText: '',
    invalidMessage: []
  }

  componentDidMount() {
    this.props.fetchAssignmentNotes(this.props.propertyAppraisalId, this.props.lin)
  }

  componentWillUnmount() {
    this.props.clearMessages()
  }

  handleChange = (event) => {
    this.props.clearMessages()
    this.setState({
      [event.target.name]: event.target.name === 'accessIndicator' ? event.target.checked : event.target.value,
      invalidMessage: []
    })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.props.clearMessages()
    this.props.postAssignmentNote(this.props.propertyAppraisalId, this.state, this.props.lin)
    this.setState({
      accessIndicator: false,
      noteType: '',
      noteText: ''
    })
  }

  handleInvalid = (event) => {
    event.preventDefault()
    event.persist()
    this.setState(prevState => ({ invalidMessage: [...prevState.invalidMessage, event.target.id] }))
  }

  handleReset = () => {
    this.props.clearMessages()
    this.setState({
      accessIndicator: false,
      noteType: '',
      noteText: '',
      invalidMessage: []
    })
  }

  render() {
    return (
      <div className='assignment-notes'>
        {this.props.noteUploads.status && <UploadSuccessOrFailureMessage
          responseMessage={this.props.noteUploads.status}
          documentTypeName='note' />}
        <AddNoteSection
          handleSubmit={this.handleSubmit}
          handleChange={this.handleChange}
          handleInvalid={this.handleInvalid}
          handleReset={this.handleReset}
          noteUploads={this.props.noteUploads}
          invalidMessage={this.state.invalidMessage}
          accessIndicator={this.state.accessIndicator}
          noteType={this.state.noteType}
          noteText={this.state.noteText} />
        <NotesHistorySection
          notes={this.props.assignmentNotes} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  assignmentNotes: state.appraiser.assignments.assignmentNotes,
  noteUploads: state.appraiser.assignments.noteUploads
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ fetchAssignmentNotes, postAssignmentNote, clearMessages }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentNotesContainer)
